import { defineComponent } from "vue";
import { useRegisterTestStore } from "@/store/RegisterTestStore";
import { mapWritableState } from "pinia";
import FloatingCard from "@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue";

export default defineComponent({
  components: {
    FloatingCard,
  },
  data() {
    return {
      registerTestStore: useRegisterTestStore(),
      hasError: false,
      hivContact: {
        until_three_days: {
          param_id: "hpyNMkJVcN",
          result: "until_three_days",
        },
        between_four_and_twenty_nine: {
          param_id: "qt28WCsZSR",
          result: "between_four_and_twenty_nine",
        },
        thirty_days_or_more: {
          param_id: "7jRF4iXGrE",
          result: "thirty_days_or_more",
        },
      },
    };
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ["testSymptoms"]),
    ...mapWritableState(useRegisterTestStore, ["canJumpNext"]),
  },
  methods: {
    setHivContact(value: any) {
      this.registerTestStore.exposureTime = value.result;
      this.registerTestStore.exposureTimeCode = value.param_id;
      this.canJumpNext = true;
      this.hasError = false;
    },
    errorValidation() {
      this.hasError = true;
      return false;
    },
    isValidStep(): boolean {
      return this.registerTestStore.exposureTime != "";
    },
    setAnimationType(animationName: string) {
      setTimeout( () => {
        const baseModal: any = this.$refs["base-modal"];
        switch (animationName) {
          case "setNextDismissAnimation":
            baseModal.setNextDismissAnimation();
            break;
          case "setNextShowAnimation":
            baseModal.setNextShowAnimation();
            break;
          case "setPreviousDismissAnimation":
            baseModal.setPreviousDismissAnimation();
            break;
          case "setPreviousShowAnimation":
            baseModal.setPreviousShowAnimation();
            break;
        }
      }, 1);
    }
  },
});
